import { render, staticRenderFns } from "./IXJMXMAG.vue?vue&type=template&id=458f89ff&scoped=true"
import script from "./IXJMXMAG.vue?vue&type=script&lang=js"
export * from "./IXJMXMAG.vue?vue&type=script&lang=js"
import style0 from "./IXJMXMAG.vue?vue&type=style&index=0&id=458f89ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458f89ff",
  null
  
)

export default component.exports